import React from 'react';

import './portfolio.css'

import PortfolioItem from "./portfolioItem/portfolioItem"

import FinanceImage from "../../assets/financePic.png"

import DesignStudioPic from "../../assets/designStudio.png"

import YourHairCutThumbnail from "../../assets/haircut.png"

import BotsBot from "../../assets/bots.png"

import TradingView from "../../assets/tradingView.png"

import Sicken from "../../assets/sickenLanding.png"

import HowWeLive from '../../assets/howWeLive.png'

function Portfolio() {
    return (
      <div className="portfolio--container">
        <div className="portfolio--header">
            Check Out our Portfolio of Works
        </div>
        <div className="portfolio--sub--header">
            Visit Live Links And Check Them Out
        </div>
        <PortfolioItem link="https://designwoodprint.com/pages/studio"
                       altText="Link Temporarily Unavailbe"
                       thumbnail={DesignStudioPic}
                       title="Unrefined Art"
                       description="Developed a photo editing app within client's Shopify store. Editor allows photo upload
                       along with and size adjustments along with a variety of other editing options. 
                       Connected with backend file construction to prepare the customers design for printing, as well as automing customer data."
                       offset={false}
        ></PortfolioItem>
        <PortfolioItem link="https://financeforleasingtobuy.web.app/"
                       altText="Link Temporarily Unavailbe"
                       thumbnail={FinanceImage}
                       title="Finance For Lease To Buy"
                       description="Developed a landing page from mock-up and integreated a form for user sign-up. 
                       Integrated multile payment gateways for user sign-up. Connected custom form to Zoho, and devloped CRM automation in Deluge.
                       Also, created endpoint for reactive form modification from Zoho."
                       offset={true}
        ></PortfolioItem>
       
        <PortfolioItem link="https://sicken-e468e.web.app/"
                       altText="Link Temporarily Unavailbe"
                       thumbnail={Sicken}
                       title="Sicken"
                       description="Designed and developed a landing page and website for local comic book start-up 'Sicken Extreme Eye for an Eye'.
                       Edited existing assets to create a modern web design."
                       offset={false}
        ></PortfolioItem>
        <PortfolioItem link="https://yourhaircutdelivered.web.app/"
                       altText="Link Temporarily Unavailbe"
                       thumbnail={YourHairCutThumbnail}
                       title="Your Haircut Delivered"
                       description="Custom built web application to allow user's to sign up as a seller, or search for a barber near them. Integrated re-occuring subscription with Paypal."
                       offset={true}
        ></PortfolioItem>
        <PortfolioItem 
                       altText="Link Unavailbe For Secuirity Reasons"
                       thumbnail={BotsBot}
                       title="Bot's Bot"
                       description="Custom middle man application between TradingView and 3commas crypto ytading services.
                       Allows user to create and customize conditions based on inbound pings from TadingView and send pings to 3commas to turn bots off or on.
                       Designed around optimal server performance to recieve and issue request within a second. "
                       offset={false}
        ></PortfolioItem>
        <PortfolioItem link="https://www.tradingview.com/script/v1XoZy92-Mejia-Cloud/"
                       altText="Link Coming Soon"
                       thumbnail={TradingView}
                       title="Trading View Script"
                       description="Developed a custom Indicator based in TradingView's pinescript. 
                       Uses the Ichimoku pattern as well as serveral other patterns to create a buy indicator."
                       offset={true}
        ></PortfolioItem>
        <PortfolioItem link="https://howwelive.co/"
                       altText="Link Coming Soon"
                       thumbnail={HowWeLive}
                       title="It's How We Live"
                       description="Built a custom Survey Application within the client's shopify Store.
                        Finishing the survey allow's user's to pick their favorite family values that correspond to their survey results.
                        Selected values are then generated into wall art, which is scaled for printing server-side."
                       offset={false}
        ></PortfolioItem>
        
      </div>
    )
  }
  
export default Portfolio;
  